<div echarts [options]="options" class="area-distribution-chart"></div>
